const menus = [
    {
        id: 1,
        name: 'HOME',
        linkmenu: '#',
        namesub: [
            {
                id: 1,
                sub: 'HOME 01',
                links: '/',
                submenu: undefined
            },
            {
                id: 2,
                sub: 'HOME 02',
                links: '/home-02',
                submenu: undefined
            },
            {
                id: 3,
                sub: 'HOME 03',
                links: '/home-03',
                submenu: undefined
            },
            {
                id: 4,
                sub: 'HOME 04',
                links: '/home-04',
                submenu: undefined
            },
            {
                id: 5,
                sub: 'HOME ANIMATE',
                links: '/home-animate',
                submenu: undefined
            },
        ]
    },
    {
        id: 2,
        name: 'COURSES',
        linkmenu: '#',
        namesub: [
            {
                id: 1,
                sub: 'COURSES V1',
                links: '/courses-grid-v1',
                submenu: undefined
            },
            {
                id: 2,
                sub: 'COURSES V2',
                links: '/courses-grid-v2',
                submenu: undefined
            },
            {
                id: 3,
                sub: 'COURSES V3',
                links: '/courses-grid-v3',
                submenu: undefined
            },
            {
                id: 4,
                sub: 'COURSES SINGLE',
                links: '/courses-single',
                submenu: undefined
            }
        ],
    },
    {
        id: 3,
        name: 'INSTRUCTORS',
        linkmenu: '/instructors',
        namesub: undefined
    },
    {
        id: 4,
        name: 'EVENTS',
        linkmenu: '#',
        namesub: [
            {
                id: 1,
                sub: 'EVENT V1',
                links: '/event-v1',
                submenu: undefined
            },
            {
                id: 2,
                sub: 'EVENT V2',
                links: '/event-v2',
                submenu: undefined
            },
            {
                id: 3,
                sub: 'EVENT SINGLE',
                links: '/event-single',
                submenu: undefined
            }
        ],
    },
    {
        id: 5,
        name: 'PAGES',
        linkmenu: '#',
        namesub: [
            {
                id: 1,
                sub: 'FAQs',
                links: '/faq',
                submenu: undefined
            },
            {
                id: 2,
                sub: 'ABOUT US',
                links: '/about-us',
                submenu: undefined
            },
            {
                id: 3,
                sub: 'SHOP',
                links: '#',
                submenu: [
                    {
                        id: 1,
                        titlesub: 'SHOP',
                        linksub: '/shop'
                    },
                    {
                        id: 2,
                        titlesub: 'SHOP SINGLE',
                        linksub: '/shop-single'
                    }
                ]
            }

        ],
    },
    {
        id: 6,
        name: 'BLOG',
        linkmenu: '#',
        namesub: [
            {
                id: 1,
                sub: 'BLOG',
                links: '/blog',
                submenu: undefined
            },
            {
                id: 2,
                sub: 'BLOG SINGLE',
                links: '/blog-single',
                submenu: undefined
            }
        ],
    }
]

export default menus;